import React, { useState } from 'react';
import { BedDouble, Bus, Copy, Check, Train } from 'lucide-react';
import './Lodging.css';

const Lodging = () => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText('F38');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="lodging-wrapper">
            <section id="lodging" className="section-container">
                <h2 className="section-title">Lodging & Travel</h2>

                <div className="lodging-grid">
                    <div className="info-card">
                        <div className="icon-wrapper">
                            <BedDouble size={32} />
                        </div>
                        <h3>Hotel Block</h3>
                        <p className="hotel-name">Holiday Inn Express & Suites<br />Mount Arlington-Rockaway</p>
                        <div className="hotel-contact">
                            <p>W938+6P Mt Arlington, New Jersey</p>
                            <p>1 888 HOLIDAY (1 888 465 4329)</p>
                        </div>
                        <p>We have reserved a block of rooms for our guests. Please use our reference code when booking. We recommend calling to book for the easiest experience applying the room block.</p>
                        <div className="reference-code-container">
                            <span>Reference Code:</span>
                            <div className="code-inline">
                                <strong>F38</strong>
                                <button className="copy-btn" onClick={handleCopy} title="Copy Code">
                                    {copied ? <Check size={20} color="green" /> : <Copy size={20} />}
                                </button>
                            </div>
                        </div>
                        <a href="https://www.ihg.com/holidayinnexpress/hotels/us/en/mount-arlington/hbmnj/hoteldetail" target="_blank" rel="noopener noreferrer" className="btn secondary mt-4">Book a Room</a>
                    </div>

                    <div className="info-card">
                        <div className="icon-wrapper">
                            <Bus size={32} />
                        </div>
                        <h3>Shuttle Service</h3>
                        <p className="hotel-name">To & From the Venue</p>
                        <p>Complimentary shuttle transportation will be provided between the hotel and David's Country Inn for our guests.</p>

                        <div className="shuttle-schedule">
                            <div className="shuttle-item">
                                <div className="shuttle-item-header">
                                    <span className="shuttle-route">To the Venue</span>
                                    <span className="shuttle-times">4:30 PM</span>
                                </div>
                                <p className="shuttle-detail">Departs Holiday Inn Express lobby to David's Country Inn ahead of the 5:30 PM ceremony.</p>
                            </div>

                            <div className="shuttle-item">
                                <div className="shuttle-item-header">
                                    <span className="shuttle-route">Back to the Hotel</span>
                                    <span className="shuttle-times">10:15 PM &amp; 11:00 PM</span>
                                </div>
                                <p className="shuttle-detail">Departs David's Country Inn back to the hotel (early return &amp; end of reception).</p>
                            </div>
                        </div>

                        <p className="shuttle-note">Please plan to be in the hotel lobby a few minutes prior to the 4:30 PM departure.</p>
                    </div>
                </div>

                <div className="info-card transit-card">
                    <div className="icon-wrapper">
                        <Train size={32} />
                    </div>
                    <div className="transit-content">
                        <h3>NYC Transit</h3>
                        <p className="hotel-name">Montclair-Boonton Rail Line</p>
                        <p>For guests traveling from the NYC area, NJ Transit provides WEEKDAY rail service to the <strong>Mount Arlington</strong> station, which is the closest and most convenient stop for the hotel.</p>
                        <p style={{ marginTop: '10px' }}>The train service begins in Hoboken and is an estimated 2 hour ride. Hoboken Station is easily accessed via public transit from Newark Airport, for those flying.</p>
                        <p style={{ marginTop: '10px' }}>Please note that the Montclair-Boonton line is primarily a WEEKDAY line and does not run all the way to Hackettstown on weekends.</p>
                        <div className="transit-links">
                            <a href="https://content.njtransit.com/sites/default/files/MC-WKDY-053126.pdf" target="_blank" rel="noopener noreferrer" className="btn secondary">Weekday Schedule</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Lodging;
